<template>
  <v-container>
    <v-layout column justify-center mt-1 mb-3>
      <o-big-logo/>
      <o-common-title>{{title}}</o-common-title>
      <o-description-title v-if="description"><span v-html="description"></span></o-description-title>
      <slot></slot>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/layouts/LogoLayout.vue